import { AlertTriangle, RefreshCw } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Skeleton } from '@/components/ui/Skeleton';
import { SplitSection } from '@/features/policies/components';
import { useSplit } from '@/features/policies/hooks';
import { ROUTES } from '@/constants';

const BREADCRUMBS = [
  { label: 'Inicio', path: ROUTES.DASHBOARD },
  { label: 'Operaciones', path: ROUTES.SPLIT_CONFIG },
  { label: 'Split', path: ROUTES.SPLIT_CONFIG },
];

export function SplitPage() {
  const { split, updateSplit, isSaving, isLoading, isError } = useSplit();

  if (isLoading) {
    return (
      <div>
        <PageHeader title="Distribucion de Intereses" breadcrumbs={BREADCRUMBS} />
        <Skeleton variant="rectangular" height={200} />
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        <PageHeader title="Distribucion de Intereses" breadcrumbs={BREADCRUMBS} />
        <div className="flex flex-col items-center rounded-lg border border-border bg-card px-6 py-16">
          <AlertTriangle size={48} className="mb-4 text-muted-foreground" />
          <h3 className="text-lg font-semibold">Error al cargar configuracion de split</h3>
          <Button className="mt-4" onClick={() => window.location.reload()}>
            <RefreshCw size={16} /> Reintentar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="Distribucion de Intereses"
        subtitle="Configuracion del split de ingresos entre Fiado y UNE-Credito"
        breadcrumbs={BREADCRUMBS}
      />
      <SplitSection data={split} canEdit onSave={updateSplit} isSaving={isSaving} />
    </div>
  );
}
